import React from 'react'

const Invoicing = () => {
  return (
    <div>Invoicing</div>
  )
}

export default Invoicing